import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ItsClientAreaComponent } from './layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

@NgModule({
    declarations: [
        ItsClientAreaComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        SidebarComponent,
        HeaderComponent,
        FooterComponent
    ],
    exports: [
        ItsClientAreaComponent
    ]
})
export class ItsLayoutModule
{
}
